document.addEventListener("turbo:load", function () {
  var paymentSection = document.getElementById("payment-method-section");
  if (!paymentSection) return;

  var clientId = paymentSection.dataset.paypalClientId;
  if (!clientId || typeof window.paypal === "undefined") return;

  var eventSlug = paymentSection.dataset.eventSlug;
  var form = document.querySelector("#booking form");
  if (!form || !eventSlug) return;

  var paymentMethodInput = document.getElementById("event_booking_payment_method");
  var orderIdInput = document.getElementById("event_booking_order_id");
  var cardFieldsContainer = document.getElementById("card-fields-container");
  var paypalButtonContainer = document.getElementById("paypal-button-container");
  var cardFieldErrors = document.getElementById("card-field-errors");
  var paymentErrorMessage = document.getElementById("payment-error-message");
  var desktopSubmitBtn = document.getElementById("desktop-submit-btn");
  var mobileSubmitBtn = document.getElementById("mobile-submit-btn");

  var cardSession = null;
  var paypalSession = null;
  var isSubmitting = false;

  function showError(message) {
    if (paymentErrorMessage) {
      paymentErrorMessage.textContent = message;
      paymentErrorMessage.style.display = "block";
    }
    if (cardFieldErrors) {
      cardFieldErrors.textContent = message;
      cardFieldErrors.style.display = "block";
    }
  }

  function hideError() {
    if (paymentErrorMessage) {
      paymentErrorMessage.style.display = "none";
      paymentErrorMessage.textContent = "";
    }
    if (cardFieldErrors) {
      cardFieldErrors.style.display = "none";
      cardFieldErrors.textContent = "";
    }
  }

  function collectFormData() {
    return {
      amount: (form.querySelector('[name="event_booking[amount]"]') || {}).value || "1",
      coupon_code: (form.querySelector('[name="event_booking[coupon_code]"]') || {}).value || "",
      first_name: (form.querySelector('[name="event_booking[first_name]"]') || {}).value || "",
      last_name: (form.querySelector('[name="event_booking[last_name]"]') || {}).value || "",
      street: (form.querySelector('[name="event_booking[street]"]') || {}).value || "",
      postcode: (form.querySelector('[name="event_booking[postcode]"]') || {}).value || "",
      city: (form.querySelector('[name="event_booking[city]"]') || {}).value || "",
      country: (form.querySelector('[name="event_booking[country]"]') || {}).value || "de",
      vat_number: (form.querySelector('[name="event_booking[vat_number]"]') || {}).value || "",
      company: (form.querySelector('[name="event_booking[company]"]') || {}).value || "",
      email: (form.querySelector('[name="event_booking[email]"]') || {}).value || "",
      phone: (form.querySelector('[name="event_booking[phone]"]') || {}).value || ""
    };
  }

  function validateRequiredFields() {
    var formData = collectFormData();
    var required = ["first_name", "last_name", "street", "postcode", "city", "email"];
    var missing = required.filter(function (f) { return !formData[f]; });
    if (missing.length > 0) {
      showError("Bitte fülle alle Pflichtfelder aus, bevor du bezahlst.");
      return false;
    }
    return true;
  }

  async function createPayPalOrder() {
    var formData = collectFormData();
    var response = await fetch("/api/events/" + eventSlug + "/event_bookings/create_paypal_order", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData)
    });

    var data = await response.json();

    if (!response.ok || data.error) {
      var errorMsg = data.error || "PayPal-Order konnte nicht erstellt werden.";
      showError(errorMsg);
      throw new Error(errorMsg);
    }

    return { orderId: data.id };
  }

  function submitFormWithPayPal(orderId) {
    orderIdInput.value = orderId;
    paymentMethodInput.value = "paypal";
    isSubmitting = true;
    form.submit();
  }

  function disableSubmitButtons() {
    if (desktopSubmitBtn) desktopSubmitBtn.disabled = true;
    if (mobileSubmitBtn) mobileSubmitBtn.disabled = true;
  }

  function enableSubmitButtons() {
    if (desktopSubmitBtn) desktopSubmitBtn.disabled = false;
    if (mobileSubmitBtn) mobileSubmitBtn.disabled = false;
    form.classList.remove("is-submitting");
  }

  // --- v6 SDK Initialization ---
  async function initPayPal() {
    var sdk;
    try {
      sdk = await window.paypal.createInstance({
        clientId: clientId,
        components: ["card-fields"],
        pageType: "checkout"
      });
    } catch (err) {
      console.error("PayPal SDK init error:", err);
      return;
    }

    // --- CardFields Setup (defensive: skip eligibility check per PayPal docs) ---
    try {
      cardSession = sdk.createCardFieldsOneTimePaymentSession();

      var fieldStyle = {
        input: {
          padding: "8px 12px"
        }
      };

      var numberField = cardSession.createCardFieldsComponent({
        type: "number",
        placeholder: "Kartennummer",
        style: fieldStyle
      });
      var expiryField = cardSession.createCardFieldsComponent({
        type: "expiry",
        placeholder: "MM/JJ",
        style: fieldStyle
      });
      var cvvField = cardSession.createCardFieldsComponent({
        type: "cvv",
        placeholder: "CVV",
        style: fieldStyle
      });

      document.getElementById("card-number-field").appendChild(numberField);
      document.getElementById("card-expiry-field").appendChild(expiryField);
      document.getElementById("card-cvv-field").appendChild(cvvField);
    } catch (err) {
      console.warn("PayPal CardFields not available:", err);
      var ccWrapper = document.querySelector('.payment-option-wrapper[data-payment="creditcard"]');
      if (ccWrapper) ccWrapper.style.display = "none";
    }

    // --- PayPal Button Setup (defensive: try regardless of eligibility) ---
    try {
      paypalSession = sdk.createPayPalOneTimePaymentSession({
        onApprove: async function (data) {
          submitFormWithPayPal(data.orderId);
        },
        onCancel: function () {
          enableSubmitButtons();
        },
        onError: function (err) {
          console.error("PayPal error:", err);
          enableSubmitButtons();
          showError("Fehler bei der PayPal-Zahlung. Bitte versuche es erneut.");
        }
      });

      var ppContainer = document.getElementById("paypal-button-container");
      if (ppContainer) {
        var ppBtn = document.createElement("paypal-button");
        ppContainer.appendChild(ppBtn);

        ppBtn.addEventListener("click", async function () {
          hideError();
          if (!validateRequiredFields()) return;
          disableSubmitButtons();

          try {
            await paypalSession.start(
              { presentationMode: "auto" },
              createPayPalOrder()
            );
          } catch (err) {
            console.error("PayPal start error:", err);
            enableSubmitButtons();
          }
        });
      }
    } catch (err) {
      console.warn("PayPal Buttons not available:", err);
      var ppWrapper = document.querySelector('.payment-option-wrapper[data-payment="paypal"]');
      if (ppWrapper) ppWrapper.style.display = "none";
    }
  }

  initPayPal();

  // --- Payment Method Toggle ---
  function setActivePaymentOption(value) {
    paymentMethodInput.value = (value === "creditcard" || value === "paypal") ? "paypal" : "invoice";
    hideError();

    document.querySelectorAll(".payment-option").forEach(function (el) {
      el.classList.remove("payment-option--active");
    });

    var activeLabel = document.querySelector('.payment-option[data-payment="' + value + '"]');
    if (activeLabel) {
      activeLabel.classList.add("payment-option--active");
    }

    if (cardFieldsContainer) {
      cardFieldsContainer.style.display = value === "creditcard" ? "block" : "none";
      var wrapper = cardFieldsContainer.closest(".payment-option-wrapper");
      if (wrapper) {
        var label = wrapper.querySelector(".payment-option");
        if (label) {
          label.classList.toggle("rounded-bottom-0", value === "creditcard");
        }
      }
    }

    if (paypalButtonContainer) {
      paypalButtonContainer.style.display = value === "paypal" ? "block" : "none";
      var wrapper = paypalButtonContainer.closest(".payment-option-wrapper");
      if (wrapper) {
        var label = wrapper.querySelector(".payment-option");
        if (label) {
          label.classList.toggle("rounded-bottom-0", value === "paypal");
        }
      }
    }
  }

  document.querySelectorAll('input[name="payment-option"]').forEach(function (radio) {
    radio.addEventListener("change", function (e) {
      setActivePaymentOption(e.target.value);
    });
  });

  // --- Submit Interception for CardFields ---
  form.addEventListener("submit", async function (e) {
    if (isSubmitting) return;

    var selectedPayment = (document.querySelector('input[name="payment-option"]:checked') || {}).value;

    if (selectedPayment === "creditcard" && cardSession) {
      e.preventDefault();
      form.classList.remove("is-submitting");
      hideError();

      if (!validateRequiredFields()) return;

      disableSubmitButtons();

      try {
        var orderResult = await createPayPalOrder();
        var orderId = orderResult.orderId;

        var result = await cardSession.submit(orderId, {
          billingAddress: {
            postalCode: collectFormData().postcode
          }
        });

        switch (result.state) {
          case "succeeded":
            submitFormWithPayPal(result.data.orderId);
            break;
          case "canceled":
            showError("Die Authentifizierung wurde abgebrochen. Bitte versuche es erneut.");
            break;
          case "failed":
            showError((result.data && result.data.message) || "Kartenzahlung fehlgeschlagen. Bitte prüfe deine Kartendaten.");
            break;
        }
      } catch (err) {
        console.error("CardFields submit error:", err);
        var msg = (err && err.message) || "Fehler bei der Kartenzahlung. Bitte prüfe deine Kartendaten.";
        showError(msg);
      } finally {
        enableSubmitButtons();
      }
    }
  });
});
